/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import {getHost, reduceParams, parseParams, querystring} from '@ywfe/utils';



  const {basePath = '', loginPath = ''} = getHost("PRO_SETTLE", "446")



  
    
      export interface API48280Item {
        
      /**  */
      id?: number;
        
      /** 任务id */
      taskId?: number;
        
      /** 任务动态 */
      content?: string;
        
      /** 操作人id */
      operatorId?: string;
        
      /** 操作人姓名 */
      operatorName?: string;
        
      /** 头像 */
      headIconUrl?: string;
        
      /** 操作时间yyyy-MM-ddHH:mm:ss */
      optTime?: any;
        
      };
    
  



  export interface API48280Req {
  
      /** (Long) */
      taskId?: string;
    
  };



  export interface API48280Res {
    /** T  */
    list?: API48280Item[];
    /**   */
    totalNumber?: any;
    /**   */
    totalPage?: any;
    /**   */
    rowId?: string;
    /**   */
    hasNext?: boolean;
    /**   */
    pageSize?: any;
    /**   */
    pageIndex?: any;
    
  };


// 48280 查询任务日志列表

export const useGetAPI48280 = () => {
  let isMount = true;
  const [isAPI48280Loading, setIsAPI48280Loading] = useState(false);
  const [dataAPI48280, setDataAPI48280] = useState<API48280Res>({} as API48280Res);
  const fetchAPI48280Data = async (inputs: API48280Req, config?: YWRequestConfig): Promise<API48280Res> => {
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API48280Req>) || {}) as API48280Req;
    
    if ( isMount ) {
      setIsAPI48280Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API48280Res>(`${basePath}/team-work/workTask/listWorkTaskLog?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI48280(res || {} as API48280Res);
        setIsAPI48280Loading(false);
      }
      return res;
    } catch (error) {
      console.error('API error: ', error);
      if ( isMount ) {
        setIsAPI48280Loading(false);
      }
      return false as unknown as API48280Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48280Loading,
    dataAPI48280,
    fetchAPI48280Data,
  }
}

